<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("autoemailreport") }}</div>
      <router-link class="btn-blue" to="add-auto-email-report">{{
        $t("add")
      }}</router-link>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="filterIsActive => {
            this.GetAllAutoEmailReport(filterIsActive);
          }"
        />
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-center">
              <img
                v-if="this.columnName != 'email_id'"
                @click="onSortValue('email_id', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('email_id', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('email_id', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("email") }} {{ $t("address") }}
            </th>
            <th class="text-center">{{ $t("report") }} {{ $t("name") }}</th>
            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="emailreoprtList.length > 0">
          <tr
            v-for="(emailreport, emailreportIndex) in emailreoprtList"
            :key="emailreportIndex"
          >
            <td class="text-center">{{ emailreport.email_id }}</td>
            <td class="text-center">{{ emailreport.rl_name }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    disabled
                    :checked="emailreport.aec_is_active == 'Y'"
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    emailreport.aec_is_active === 'Y'
                      ? 'active'
                      : emailreport.aec_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-on:click="onEmailReport('Edit', emailreport)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <!--
                  <b-dropdown-item v-on:click="onTicketTemp('View', tickettemp.tt_id) ">
                    <span class="icon-eye"></span>
                    {{ $t('view') }}
                  </b-dropdown-item>-->
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords/>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      viewingnumbers: [],
      emailreoprtList: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  beforeMount() {
    this.GetAllAutoEmailReport();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetAllAutoEmailReport();
      } else {
        this.currentPage = event;
        this.GetAllAutoEmailReport();
      }
    },

    onEmailReport: function(type, data) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-auto-email-report",
          query: { aec_id: data.aec_id }
        });
      }
      //  else {
      //   this.$router.push({
      //     path: "/master/view-cinema-ticket-templates",
      //     query: { tt_id: id }
      //   });
      // }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.GetAllAutoEmailReport();
    },

    GetAllAutoEmailReport: function(filter_is_active = 'Y') {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: filter_is_active,
      };

      MasterService.GetAutoEmailReport(body).then(response => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.emailreoprtList = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailReportComponents/listautoemailreport.vue